import { fetchSCS } from '@cube/utils/lib/scs-api';
import { serialize } from './utils';

export function fetchFromDailyMotionPlaylist({ startContentServiceOrigin, streamClient, dmPlaylist, limit, page }) {
	let queryParams = {};

	if (limit) queryParams.limit = limit;
	if (page) queryParams.page = page;

	return fetchSCS(`/dailymotion/playlist/${dmPlaylist}/${serialize(queryParams)}`, streamClient, startContentServiceOrigin);
}

export function fetchFromDailyMotionRelatedVideos({ startContentServiceOrigin, streamClient, article, limit, page }) {
	let queryParams = {};

	if (limit) queryParams.limit = limit;
	if (page) queryParams.page = page;

	return fetchSCS(`/dailymotion/relatedvideos/${article}/${serialize(queryParams)}`, streamClient, startContentServiceOrigin);
}
